// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal, { type ModalDialogProps } from '@atlaskit/modal-dialog';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerModal = withChoreographedRender<ModalDialogProps>(Modal);
